import clsx from "clsx";
import { DisclaimerData } from "@/pages/quiz/base/questions/disclaimerAcknowledgment/common";

type Props<T> = {
  disclaimerData: DisclaimerData<T>;
};

const Disclaimer = <T extends string>({ disclaimerData }: Props<T>) => {
  return (
    <div
      className={clsx(
        "flex flex-col gap-3 border rounded-3xl border-gray py-4"
      )}
    >
      <h3 className="font-medium text-lg px-5">{disclaimerData.title}</h3>
      <div className="border-b border-gray px-5" />
      <div className="quiz-description space-y-3 px-3 mx-2 text-sm pb-4">
        <div className="text-[15px]">{disclaimerData.body}</div>
      </div>
    </div>
  );
};

export { Disclaimer };
